import {
  deleteChangeInitiation,
  getAll,    
} from "../services/ChangeInitiation-service";                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
import React, { useState, useEffect, useRef, Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Table, Button, Col, Container, Form, Row, Stack } from "react-bootstrap";
import { BrowserRouter as Router, Link, Route, Routes, useLinkClickHandler } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import ComboBox from 'react-responsive-combo-box'

function ChangeInitiationDashboard() {
  var username =localStorage.getItem('UserName');
  var useremail = localStorage.getItem('UserId');  
   let query = window.location.href
    let indication="";  
   indication=query.split("/").pop();
  const navigate = useNavigate();
  const [ChangeInitiation, setChangeInitiation] = useState([]);
  useEffect(() => {
    fetchChangeInitiation();
  }, []);

  const fetchChangeInitiation = async () => {
    const result = await getAll();
    
    let filteredResult=[];
    switch (indication) {        
      case "Raised":
        alert(indication);
       filteredResult = result.filter((item) =>  (item.ChangeInitiationOwnerEmail==useremail && item.ChangeApprovedbyGC != "Yes" ) );
       
       setChangeInitiation(filteredResult);
        break;
      case 'approvalrequest':
        alert(indication);
        
        filteredResult = result.filter((item) =>  (((item.DMCMember==username && item.ApprovedByDmc !="Yes")
         || (item.PDASpocName==username && item.ApprovedByPDATeam !="Yes" && item.ApprovedByDmc =="Yes")
         || (item.DMCMemberOwner==useremail && item.ChangeAcceptedbyDMC !="Yes" && item.ApprovedByPDATeam =="Yes")
         || (item.PDAApprover==username && item.ChangeValidatedByPDA !="Yes" && item.ChangeAcceptedbyDMC =="Yes")
         || (item.GCApprover==username && item.ChangeApprovedbyGC !="Yes" && item.ApprovedByPDATeam =="Yes")
         || (item.PDAStopWorkApprover==useremail && item.StopWorkApprovedByPda !="Yes" && item.StopWorkApprovedByDMC =="Yes")
         || (item.GCStopWorkApprover==useremail && item.StopWorkApprovedByGC !="Yes" && item.StopWorkApprovedByPda =="Yes")
         )) && (item.ChangeApprovedbyGC != "Yes")) ;
        setChangeInitiation(filteredResult);

        
        break;
      case 'approvedrequest':
        alert(indication);
        filteredResult = result.filter((item) =>  item.ChangeApprovedbyGC == "Yes");
        setChangeInitiation(filteredResult);
        break;
        case 'pdainitiation':
          alert(indication);
          filteredResult = result.filter((item) =>  item.ChangeInitiationOwnerEmail==useremail);
          setChangeInitiation(filteredResult);
          break;
      default:
        setChangeInitiation(result);
    }
    
  };

  const handleView = (row) => {
    var  ChangeReqNo= row.ChangeRequestNumber;
    var ProjectNumber= row.ProjectNumber;
    
    sessionStorage.setItem('ChangeReqNo', ChangeReqNo );   
    sessionStorage.setItem('ProjNo', ProjectNumber );     
      navigate("/changeinitiationdetailscreen");     
    
  };

  const handleDelete = (row) => {
   
    deleteChangeInitiation(row.ProjectNumber, row.ChangeRequestNumber)
      .then((resp) => {
        if (resp.data.status) {
      
          fetchChangeInitiation();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  

  const deleteButton = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button
        size="sm"
        variant="outline-danger"
        onClick={() => {
          handleDelete(row);
        }}
      >
        
        Delete
      </Button>
    );
  };

  const viewButton = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button
        size="sm"
        variant="outline-success"
        onClick={() => {
          handleView(row);
        }}
      >
        View
      </Button>
    );
  };


  return (
    
    <Container className="LogbookForm">       
         
    <div>
         <div class="float-start">
  <Button class="btn-primary"
  style={{ float: "right" } }
 size="sm"
 onClick={() => {
  navigate("/Raised")
 }}
>
Back
</Button>
</div>
    {/* <Link to={"/Raised"}>Back to dashboard</Link> */}
   
    {/* <Button size="sm" class="d-block mr-0 ml-auto"  variant="outline-success" onClick={routeChange}  >  Edit </Button> */}
    </div>
    <br></br>
    <br></br>
    <h5> <span class="text-primary">Change Initiation </span></h5>
         {/* <h2 >Create New LogBook Request</h2> */}
         <hr />
         {ChangeInitiation.map((Cidata, index) =>
         <Form className="form" key={index} >  
         <Row>
           <Col width="70%">
             <Row>
               
                   <Col width="70%">
                   <Form.Group className="mb-3">
                        <Form.Label>Change Request Number : {Cidata.ChangeRequestNumber}  </Form.Label>                         
                     </Form.Group>
                   </Col>
                
                   <Col width="30%">
                   <Form.Group className="mb-3">
                         <Form.Label> ChnageRequestDate : {Cidata.ChangeRequestDate}  </Form.Label>                         
                     </Form.Group>
                   </Col>
                
             </Row> 
             <Row>
             <Col width="20%">
                   <Form.Group className="mb-3">
                         <Form.Label> DMCName: {Cidata.DMCMember}  </Form.Label>                         
                     </Form.Group>
                   </Col>
             <Col>
                     <Form.Group className="mb-3">
                         <Form.Label>Work Type :{Cidata.WorkType} </Form.Label>                         
                     </Form.Group></Col>
             </Row>
             <Row>
             <Col>
                     <Form.Group className="mb-3">
                         <Form.Label>Project Name : {Cidata.ProjectName} </Form.Label>
                         
                     </Form.Group></Col>
                   
             </Row> 
            <Row>
             
             <Col>
                 <Form.Group className="mb-3"> 
                 <Form.Label>_________________________________________________________________________________________________________________________________</Form.Label>                 
                  </Form.Group>
                     </Col>
                
                   
             </Row>
             </Col>
             <Col  width="30%">
             <Row>
             <Col>
             <Button
        size="sm"
        style={{ float: "right" } }
        variant="outline-success"
        onClick={() => {
          handleView(Cidata);
        }}
      >
        View
      </Button> 
      {/* </Col>
      <Col  width="50%"> */}
      <Button
        size="sm"
        style={{ float: "left" } }
        variant="outline-danger"
        onClick={() => {
          handleDelete(Cidata);
        }}
      >        
        Delete
      </Button>  
      </Col> 
      </Row>         
</Col>

             </Row>           
         </Form>
         )}
     </Container>

    
  );
}  

export default ChangeInitiationDashboard; 











